module.exports = __webpack_public_path__ + "img/san.37049962.png";